import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'whatwg-fetch';
import { appendGraphQlMajorEntity, findAssociatedMajorEntity } from 'src/utils/utilPlanning';
import InputUpdate from '../input/inputUpdate';
import TextAreaUpdate from '../input/textareaUpdate';
import DatePickerUpdate from '../input/datepickerUpdate';
import TimePickerUpdate from '../input/timepickerUpdate';

import ModalReturnEmployee from '../modal/modalReturnEmployee';
import ModalConfirm from '../modal/modalConfirm';

import data_criticity from 'src/data/criticity';
import data_priority from 'src/data/priority';
import data_planning_state from 'src/data/planning-state';
import SubNavBar from '../SubNavBar';
import withAuth from 'src/hoc/withAuth';

const apiTaskShow = '/api/task/show/';
const linkToUser = '/dashboard/user/';

class DisplayTask extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      notFound: false,
      appViewNavExtended: false, // Extend the menu behind the appViewNav
      isModalTaskCloseOpen: false,
      isModalTaskChangeOpen: false,
      isModalRemoveEmployeeOpen: false,
      isModalAddEmployeeOpen: false,
      textModal: {
        title: undefined,
        message: undefined,
      },
      title: '____',
      priority: '____',
      criticity: '____',
      text: '____',
      majorEntity: undefined,
      dateCreated: '____',
      deadline: '____',
      creator: undefined,
      employeesConcerned: undefined,
      isClosed: undefined,
      closingDate: undefined,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleTaskChange = this.handleTaskChange.bind(this);
    this.changeTaskState = this.changeTaskState.bind(this);
    this.closeTask = this.closeTask.bind(this);
    this.openModal = this.openModal.bind(this);
    this.openModalTaskChange = this.openModalTaskChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.updateField = this.updateField.bind(this);
    this.updateEmployee = this.updateEmployee.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  handleTaskChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    let graphKey;

    switch (name) {
      case 'status':
        graphKey = 'state';
        break;
      case 'criticity':
        graphKey = 'criticity';
        break;
      case 'priority':
        graphKey = 'priority';
        break;
    }

    this.openModalTaskChange(graphKey, value);
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      // check if id supplied in the route
      const paramsID = this.props.match.params.id;

      let queryURL = apiTaskShow;
      let graphQL =
        '{ task(id:' +
        paramsID +
        '){ id, title, text, priority, criticity, state, closed, closingDate, deadline, dateCreate, creator{ id, user{ id, username } }, ' +
        'employeesConcerned{ id, user{ id, username } },' +
        appendGraphQlMajorEntity() +
        ' } }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['task']) {
              this.setState({
                entity: data['data']['task'],
                title: data['data']['task']['title'],
                status: data['data']['task']['state'],
                criticity: data['data']['task']['criticity'],
                priority: data['data']['task']['priority'],
                text: data['data']['task']['text'],
                majorEntity: findAssociatedMajorEntity(data['data']['task']),
                dateCreated: data['data']['task']['dateCreate'],
                deadline: data['data']['task']['deadline'],
                isClosed: data['data']['task']['closed'],
                closingDate: data['data']['task']['closingDate'],
                creator: data['data']['task']['creator'],
                employeesConcerned: data['data']['task']['employeesConcerned'],
              });
            } else {
              // not found
              this.setState({ notFound: true });
            }
          }.bind(this)
        )
        .catch(
          function (error) {
            console.log('erreur fetch task entity: \n' + error);
          }.bind(this)
        );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      // Route reloaded
      this.componentDidMount();
    }
  }

  toggleAppViewNavExtended() {
    this.setState({
      appViewNavExtended: !this.state.appViewNavExtended,
    });
  }

  render() {
    if (this.state.notFound === true || !this.props.match.params.id) return null;

    const { employeesConcerned } = this.state;

    let noEmployees =
      this.state.employeesConcerned != undefined && this.state.employeesConcerned.length === 0 ? (
        <span>Aucun employé associé</span>
      ) : (
        ''
      );

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar
          goBack={this.props.history.goBack}
          toggleAppViewNavExtended={() => this.toggleAppViewNavExtended()}
          appViewNavExtended={this.state.appViewNavExtended}
          title='Fiche Tâche'
        >
          <div className={'appViewNavMenu-alignRight'}>
            {!this.state.isClosed && (
              <button type='button' className='btn btn-sm btn-outline-success' onClick={() => this.openModal('close')}>
                <span className='icon icon-check'>Clôturer</span>
              </button>
            )}
          </div>
        </SubNavBar>

        <div id='appViewContent'>
          <div className='entity-display'>
            <form>
              <InputUpdate
                inputType={'text'}
                inputLabel={'Titre'}
                inputValue={this.state.title}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'title')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />
              {this.state.majorEntity && (
                <div className='form-group'>
                  <label>{'Associé à ' + this.state.majorEntity.label + ':'}</label>
                  <Link to={this.state.majorEntity.linkTo + this.state.majorEntity.id}>
                    <input
                      name='majorEntity'
                      value={this.state.majorEntity.name}
                      onChange={this.handleInputChange}
                      type='text'
                      className='form-control'
                      readOnly
                    />
                  </Link>
                </div>
              )}

              <DatePickerUpdate
                inputType={'text'}
                inputLabel={'Jour limite'}
                inputValue={this.state.deadline}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'date', 'deadline')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />
              <TimePickerUpdate
                inputType={'text'}
                inputLabel={'Heure limite'}
                inputValue={this.state.deadline}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'time', 'deadline')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />

              {this.state.isClosed && (
                <div className='form-group'>
                  <label>Clôturé le</label>
                  <input
                    name='closingDate'
                    value={moment(this.state.closingDate).format('DD-MM-YY à HH:mm')}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    readOnly
                  />
                </div>
              )}
              <div className='form-group'>
                <label>État</label>
                {!this.state.isClosed ? (
                  <select
                    name='status'
                    value={this.state.status}
                    onChange={this.handleTaskChange}
                    className='form-control'
                  >
                    {data_planning_state ? (
                      Object.entries(data_planning_state).map(([key, data]) => (
                        <option key={key} value={key}>
                          {key + '-' + data.fr}
                        </option>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </select>
                ) : (
                  <input
                    name='status'
                    value={'Clos'}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    readOnly
                  />
                )}
              </div>
              <div className='form-group'>
                <label>Criticité</label>
                {!this.state.isClosed ? (
                  <select
                    name='criticity'
                    value={this.state.criticity}
                    onChange={this.handleTaskChange}
                    className='form-control'
                  >
                    {data_criticity ? (
                      Object.entries(data_criticity).map(([key, data]) => (
                        <option key={key} value={key}>
                          {key + '-' + data.fr}
                        </option>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </select>
                ) : (
                  <input
                    name='criticity'
                    value={this.state.criticity + '-' + data_criticity[this.state.criticity].fr}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    readOnly
                  />
                )}
              </div>
              <div className='form-group'>
                <label>Priorité</label>
                {!this.state.isClosed ? (
                  <select
                    name='priority'
                    value={this.state.priority}
                    onChange={this.handleTaskChange}
                    className='form-control'
                  >
                    {data_priority ? (
                      Object.entries(data_priority).map(([key, data]) => (
                        <option key={key} value={key}>
                          {key + '-' + data.fr}
                        </option>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </select>
                ) : (
                  <input
                    name='priority'
                    value={this.state.priority + '-' + data_priority[this.state.priority].fr}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    readOnly
                  />
                )}
              </div>
              <div className='form-group'>
                <label>Créé le</label>
                <input
                  name='dateCreated'
                  value={moment(this.state.dateCreated).format('DD-MM-YY à HH:mm')}
                  onChange={this.handleInputChange}
                  type='text'
                  className='form-control'
                  readOnly
                />
              </div>
              {this.state.creator && (
                <div className='form-group'>
                  <label>Créateur</label>
                  <Link to={linkToUser + this.state.creator.user.id}>
                    <input
                      name='creator'
                      value={this.state.creator.user.username}
                      onChange={this.handleInputChange}
                      type='text'
                      className='form-control'
                      readOnly
                    />
                  </Link>
                </div>
              )}
              <div className='form-group'>
                <div className='alignHorizontal'>
                  <label>Personnes concernées</label>
                  <button
                    onClick={() => this.openModal('employee-add')}
                    type='button'
                    className='btn btn-sm btn-outline-success'
                  >
                    <span className='icon icon-plus'></span>
                  </button>
                </div>
                {employeesConcerned ? (
                  employeesConcerned.map((data) => (
                    <li className='list-group-item entity-row' key={data.user.id}>
                      <Link to={linkToUser + data.user.id}>
                        <span>{'@' + data.user.username}</span>
                      </Link>
                      <button
                        onClick={() => this.openModal('employee-remove', data.id)}
                        type='button'
                        className='btn btn-sm btn-outline-success'
                      >
                        <span className='icon icon-cross'></span>
                      </button>
                    </li>
                  ))
                ) : (
                  <span>Chargement...</span>
                )}
                {noEmployees}
              </div>
              <TextAreaUpdate
                inputType={'text'}
                inputLabel={'Commentaire'}
                inputValue={this.state.text}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'text')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />
            </form>
          </div>
        </div>

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalTaskChangeOpen}
          onSubmit={this.changeTaskState}
          onClose={this.closeModal}
          onCancel={this.closeModal}
        ></ModalConfirm>

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalTaskCloseOpen}
          onSubmit={this.closeTask}
          onClose={this.closeModal}
          onCancel={this.closeModal}
        ></ModalConfirm>

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalRemoveEmployeeOpen}
          onSubmit={() => this.updateEmployee([], 'employeesToRemove')}
          onClose={this.closeModal}
          onCancel={this.closeModal}
        ></ModalConfirm>

        <ModalReturnEmployee
          multi={true}
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalAddEmployeeOpen}
          openToast={this.props.openToast}
          onPostResult={(employeeList) => this.updateEmployee(employeeList, 'employeesToAdd')}
          onClose={this.closeModal}
        />
      </div>
    );
  }

  openModalTaskChange(graphKey, newState) {
    let modal = {
      title: 'Tâche',
      message: "Vous allez modifier l'état de la tâche",
    };
    this.props.toggleBlackOut();
    this.setState({
      textModal: modal,
      isModalTaskChangeOpen: true,
      taskChangeGraphKey: graphKey,
      taskChangeNewState: newState,
    });
  }

  openModal(type, param1 = undefined) {
    let toOpen = undefined;
    switch (type) {
      case 'employee-add':
        this.setState({
          textModal: {
            title: 'Tâche',
            message: 'Ajouter des employés à la tâche.',
          },
        });
        toOpen = 'isModalAddEmployeeOpen';
        break;
      case 'employee-remove':
        this.setState({
          textModal: {
            title: 'Tâche',
            message: 'Vous allez supprimer cet employé de la tâche.',
          },
          employeeIdToRemove: param1,
        });
        toOpen = 'isModalRemoveEmployeeOpen';
        break;
      case 'close':
        this.setState({
          textModal: {
            title: 'Tâche',
            message: 'Vous allez clôturer cette tâche.',
          },
        });
        toOpen = 'isModalTaskCloseOpen';
        break;
    }
    this.props.toggleBlackOut();
    this.setState({
      [toOpen]: true,
      appViewNavExtended: false,
    });
  }

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalTaskChangeOpen: false,
      isModalTaskCloseOpen: false,
      isModalRemoveEmployeeOpen: false,
      isModalAddEmployeeOpen: false,
    });
  }

  changeTaskState() {
    if (this.props.match.params.id && this.state.taskChangeGraphKey && this.state.taskChangeNewState) {
      const paramsID = this.props.match.params.id;

      let queryURL = apiTaskShow;
      let graphQL =
        'mutation{ task(id:' +
        paramsID +
        ',' +
        this.state.taskChangeGraphKey +
        ':' +
        this.state.taskChangeNewState +
        ' ){ id, ' +
        this.state.taskChangeGraphKey +
        ' } }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['task'][this.state.taskChangeGraphKey] == this.state.taskChangeNewState) {
              this.componentDidMount();
              this.props.openToast(true, 'La tâche a été modifiée');
            } else {
              this.props.openToast(false, 'Erreur modification tâche. Veuillez réessayer');
            }
          }.bind(this)
        )
        .catch(
          function (rror) {
            console.log(rror);
          }.bind(this)
        );
    }
  }

  closeTask() {
    if (this.props.match.params.id) {
      const paramsID = this.props.match.params.id;

      let queryURL = apiTaskShow;
      let graphQL = 'mutation{ task(id:' + paramsID + ',closed:true){ id, closed } }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['task']['closed'] == true) {
              this.componentDidMount();
              this.props.openToast(true, 'La tâche a été clôturée');
            } else {
              this.props.openToast(false, 'Erreur modification tâche. Veuillez réessayer');
            }
          }.bind(this)
        )
        .catch(
          function (rror) {
            console.log(rror);
            this.props.openToast(false, 'Erreur modification tâche. Veuillez réessayer');
          }.bind(this)
        );
    }
  }

  updateField(newValue, inputType, fieldName) {
    // !! Important-> the given "fieldName" attribute must be the name of the ORM attribute !!
    let newValueSent;
    if (inputType == 'text') {
      newValueSent = '"' + newValue.replace(/["]/g, '\\"') + '"';
    } else if (fieldName === 'deadline' && inputType === 'time') {
      let oldDate = moment(this.state.deadline);
      newValue = moment({
        year: oldDate.year(),
        month: oldDate.month(),
        day: oldDate.date(),
      })
        .seconds(newValue)
        .format('YYYY-MM-DD HH:mm');
      newValueSent = '"' + newValue.replace(/["]/g, '\\"') + '"';
    } else if (fieldName === 'deadline' && inputType === 'date') {
      let oldDate = moment(this.state.deadline);
      newValue = moment(newValue)
        .add({ hours: oldDate.get('hour'), minutes: oldDate.get('minute') })
        .format('YYYY-MM-DD HH:mm');
      newValueSent = '"' + newValue.replace(/["]/g, '\\"') + '"';
    } else {
      newValueSent = newValue;
    }
    let graphQL = 'mutation { task(id:' + this.props.match.params.id + ', ';
    graphQL += fieldName + ':' + newValueSent + ') { ' + fieldName + ' } }';

    let queryURL = apiTaskShow;
    let data = 'data=' + encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (fieldName === 'deadline') {
            data['data']['task'][fieldName] = moment(data['data']['task'][fieldName]).format('YYYY-MM-DD HH:mm');
          }

          if (data['data']['task'][fieldName] == newValue) {
            this.props.openToast(true, 'Votre modification a bien été prise en compte.');
            this.setState({
              [fieldName]: newValue,
            });
          } else {
            this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
          }
          //console.log(data);
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch UPDATE task entity: \n' + error);
        }.bind(this)
      );
  }

  updateEmployee(employeeList, fieldName) {
    if (fieldName === 'employeesToRemove') {
      employeeList = [
        {
          id: this.state.employeeIdToRemove,
        },
      ];
    }

    let graphQL = 'mutation { task(id:' + this.props.match.params.id + ', ';
    graphQL +=
      fieldName +
      ':' +
      JSON.stringify(employeeList) +
      ') { ' +
      'employeesConcerned{ id, user{ id, username } }' +
      ' } }';

    let queryURL = apiTaskShow;
    let data = 'data=' + encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['task']['employeesConcerned']) {
            this.props.openToast(true, 'Votre modification a bien été prise en compte.');
            this.setState({
              employeesConcerned: data['data']['task']['employeesConcerned'],
            });
          } else {
            this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
          }
          //console.log(data);
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch UPDATE task entity: \n' + error);
        }.bind(this)
      );
  }
}

export default withAuth(DisplayTask);
